<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    anchorId?: string;
    variant?: string;
    slides?: Array<{ content: Array<ModularBlock> }>,
    preCarouselContent?: Array<ModularBlock>,
    postCarouselContent?: Array<ModularBlock>,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  slides: props.block?.slides,
  variant: props.block?.variant,
  preCarouselContent: props.block?.preCarouselContent,
  postCarouselContent: props.block?.postCarouselContent,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data" />
</template>
